import h from 'react-hyperscript';
import { Link } from 'react-router-dom';

import './Footer.css';

const Footer = () =>
  h('footer.footer', {}, [
    h('.container', {}, [
      h('.footer-logo', {}, [
        h('a.servicelink', { href: '#header' }, [
          h('img', { src: 'img/logo-scllc-dark.png', alt: 'Simple City logo' }),
        ]),
      ]),
      h('span.copyright', [`${'©'} `, new Date().getFullYear(), ' Simple City LLC. All rights reserved.']),
      h('br'),
      h('.footer-policies', {}, [
        h(Link, { to: '/terms-of-service', className: 'footer-link' }, 'Terms'),
        ' :: ',
        h(Link, { to: '/privacy', className: 'footer-link' }, 'Privacy'),
      ]),
    ]),
  ]);

export default Footer;



// WEBPACK FOOTER //
// ./src/components/Footer/Footer.js